<template>
  <div class="warningInfo" ref="warningInfo">
    <div class="warningInfoBg">
      <div ref="chart" class="charts"></div>
    </div>
  </div>
</template>
<script>
import iframePup from "@/modules/iframePup/iframePup.vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';
export default {
  props: ["matrix", "x", "y"],
  name: "告警中心",
  data() {
    return {
      customerId: this.$store.state.customerId,
      tabPosition: "left",
      currentLabel: "offline",
      activeClass: "activeLable",
      warningData_: [
        {
          label: "离线告警",
          value: 0,
          key: "offline",
          alarmData: [],
        }
      ],
      timer: null,
      startTime: "",
      endTime: "",
    };
  },

  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },

  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },

  created() {
    this.styleType = this.$store.state.styleType;
  },

  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.chart.on("click", this.pieClick);
    this.setOriginWarnData();
  },
  unmounted() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    setOriginWarnData() {
      this.setWarnDataByTab("offline");
      this.timer = setInterval(() => {
        this.setWarnDataByTab("offline");
      }, 1000 * 60);
    },
    async setWarnDataByTab() {
      let res = await this.getAlarmInfos();
      let options = this.setWaningOption(0);
      this.chart.setOption(options);
    },
    setWaningOption(type) {
      let data = [];
      data = this.warningData_[type].alarmData;
      let option = {
        title: {
          text: "告警中心",
          show: false,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          bottom: 21,
          left: "right",
          textStyle: {
            fontSize: 14,
            color: "#FFF",
          }
        },
        color: ["#35f7d8", "#44c6fe", "#4178d3", "#5b50de"],
        series: [
          {
            name: "告警数量",
            type: "pie",
            radius: "90%",
            data: data,
            label: {
              normal: {
                show: true,
                position: "inner",
                fontStyle: "oblique",
                fontWeight: "bolder",
                formatter: "{c}",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
    changeTab(obj, index) {
      // this.currentLabel = obj.label
      this.currentLabel = obj.key;
      this.chart.clear();
      let option = this.setWaningOption(index);
      this.chart.setOption(option);
    },
    pieClick(param) {
      let WarningType = 'offline';
      this.closePop();
      let WarnSubCase = param.name;
      this.$store.commit("dialogStatus", true);
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog: `${window.bmeConfig.baseUrlHttp}/standard/${window.CONFIG.requestName}/page/warnData/WarnDataInfos.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}&warnType=${WarningType}&warnSubCase=${WarnSubCase}&startTime=${this.startTime}&endTime=${this.endTime}` +(window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
      },null,'warnCenter');
    },
    closePop() {
      let that = this._.appContext.app;
      this.$popup.close(that,'warnCenter');
    },

    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {
          $(".warnRanking .block0").addClass("block4");

          $(".warnRanking .block1").addClass("block5");

          $(".warnRanking .block2").addClass("block6");

          $(".warnRanking>ul").addClass("ul_green");
        });
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {
          $(".warnRanking .block0").removeClass("block4");

          $(".warnRanking .block1").removeClass("block5");

          $(".warnRanking .block2").removeClass("block6");

          $(".warnRanking>ul").removeClass("ul_green");
        });
      }
    },

    async getAlarmInfos() {
      let AlarmInfos = CONFIG.requestName + this.$apiOpt.getWarnData;

      this.startTime = JSON.parse(
        JSON.stringify(
          moment(new Date() -  20 * 60 * 1000).format("YYYY-MM-DD HH:mm:ss")
        )
      );
      this.endTime = JSON.parse(
        JSON.stringify(moment().format("YYYY-MM-DD HH:mm:ss"))
      );
      let res = await this.$apiUtils.get(AlarmInfos, {
        customerId: this.customerId,
        startTime: this.startTime,
        endTime: this.endTime,
      });
      let alarmData = [];
      if (res) {
        // 1-超标，2-超低，3-同步率，4-离线 99-恒指
        res.allCnt.forEach((alarmObj) => {
          alarmData = [];
          res.typeCnt.forEach((subDeviceType) => {
            if (subDeviceType.eventType == alarmObj.eventType) {
              alarmData.push({
                name: subDeviceType.typeName,
                value: subDeviceType.cnt,
              });
            }
          });
          if (alarmObj.eventType == 4) {
            this.warningData_[0].value = alarmObj.cnt;
            this.warningData_[0].alarmData = alarmData;
          } 
        });
      }
    },
  },
};
</script>
  
  
  
  <style lang="scss" scoped="scoped">
.warningInfo {
  height: 250px;

  width: 600px;

  .warningInfoBg {
    width: 96%;
    margin-top: 30px;
    position: absolute;
    left: 2%;
    .leftTabs {
      width: 160px;
      height: auto;
      position: absolute;
      top: 10px;
      z-index: 200;
      p {
        display: block;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        border: 1px dashed rgb(0, 255, 222);
        border-left: none;
        text-align: center;
        // outline: 1px solid white;
        cursor: pointer;
        span {
          font-size: 14px;
        }
      }
      .activeLable {
        color: rgb(0, 255, 222) !important;
      }
    }
    .charts {
      position: absolute;
      right: 0;
      top: 0px;
      width: 100%;
      height: 200px;
      z-index: 1;
      //   outline: 1px solid red;
    }
  }
}
</style>
  
  
  